import { render } from "./HeroiconsSolidTrendingDown.vue?vue&type=template&id=2f48e950"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTrendingDown.vue"]])

export default __exports__